import { useColorMode, useColorStyle, useTheme } from '@tonic-one/react';
import { ConfigProvider, ThemeConfig } from 'antd';

/**
 * refer to https://ant.design/docs/react/migrate-less-variables-cn
 * @param props
 * @constructor
 */
export default function AntdThemeProvider(props: { children: any }) {
  const [colorMode] = useColorMode();
  const { colors } = useTheme();
  const [colorStyle] = useColorStyle({ colorMode });
  const isDark = colorMode === 'dark';
  //less var map to Component Token
  //https://ant.design/docs/react/migrate-less-variables-cn
  const theme: ThemeConfig = {
    token: {
      colorPrimary: '#1677ff',
      colorBgLayout: colors[colorStyle.background.primary],
      colorBgElevated: isDark ? '#303030' : '#e0e0e0',
      colorBgContainer: isDark ? '#212121' : '#f2f2f2',
      colorText: isDark ? 'rgba(255, 255, 255, 0.92)' : 'rgba(0, 0, 0, 0.92)',
      colorTextLightSolid: isDark
        ? 'rgba(255, 255, 255, 0.92)'
        : 'rgba(0, 0, 0, 0.92)',
      borderRadius: 0,
      boxShadow: '0 0 0 0',
      boxShadowSecondary: '0 0 0 0',
      // colorBgSpotlight: isDark ? '#424242' : '#ffffff',
    },
    components: {
      Layout: {
        siderBg: '#000',
        lightSiderBg: '#000',
      },
      Menu: {
        itemBg: 'transparent',
        darkItemBg: 'transparent',
        subMenuItemBg: '#e0e0e0',
        darkSubMenuItemBg: '#303030',
        itemColor: 'rgba(0, 0, 0, 0.47)',
        darkItemColor: 'rgba(255, 255, 255, 0.47)',
        itemHoverColor: 'rgba(0, 0, 0, 0.92)',
        darkItemHoverColor: 'rgba(255, 255, 255, 0.92)',
        colorTextSelected: 'rgb(242, 76, 79)',
        colorTextSelectedHorizontal: 'rgb(242, 76, 79)',
        itemHoverBg: '#404040',
        darkItemHoverBg: '#404040',
        itemSelectedBg: 'transparent',
        darkItemSelectedBg: 'transparent',
        colorBgSelected: 'transparent',
        colorBgSelectedHorizontal: 'transparent',
        activeBarHeight: 32,
      } as any,
      Popover: {
        popoverBg: isDark ? '#303030' : '#e0e0e0',
      } as any,
      Tree: {
        colorBorder: '#8a8a8a',
        nodeSelectedBg: 'transparent',
      },
      Select: {
        colorBgContainer: 'transparent',
        colorBorder: isDark ? '#5e5e5e' : '#adadad',
        colorPrimaryHover: '#578aef',
        borderRadius: 3,
        controlHeightLG: 36,
      },
      Tooltip: {
        colorBgSpotlight: isDark ? '#424242' : '#FFFFFF',
        borderRadius: 3,
      },
      Steps: {
        colorSplit: isDark ? '#424242 !important' : '#f2f2f2 !important',
        lineWidth: 2,
      },
    },
  };

  return <ConfigProvider theme={theme}>{props.children}</ConfigProvider>;
}
